import React from "react";

interface IProps {
  heading?: string;
  subText?: string;
}

const InfoAlert = ({ heading, subText }: IProps) => {
  return (
    <div className="no-data">
      <div className="data-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-20 h-20"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
          />
        </svg>
      </div>
      <div className="nodata-content">
        <h3 data-cy="infoAlert-heading">{heading}</h3>
        <p data-cy="infoAlert-subText">{subText}</p>
      </div>
    </div>
  );
};

export default InfoAlert;
